import { fromNow, formatDate } from '@akerolabs/akero-vue/src/filters/date'
import { writeDataToClipboard } from '@akerolabs/akero-vue/src/utils/helpers.js'
import { ToastProgrammatic } from '@akerolabs/akero-vue/src/components/toast'
import { isDemo } from '@akerolabs/akero-vue/src/services/demoMode.js'
import { entityBranding } from '@akerolabs/akero-vue/src/services/entityBranding.js'
import { accountObj } from '@akerolabs/akero-vue/src/store'

import {
  makeInstallLink,
  embedCode,
  previewLink,
  getPreviewImage,
} from '@akerolabs/akero-vue/src/services/apps.js'

import { computed } from 'vue'

export default function appsListRowMixin(context) {
  const leadsBrandingPlural = computed(() =>
    entityBranding('leads.plural', 'Leads'),
  )
  const leadsBrandingSingle = computed(() =>
    entityBranding('leads.singular', 'Lead'),
  )

  const demoClass = computed(() => ({ blur: isDemo() }))

  const appLink = computed(() => {
    const { app } = context.props
    let toState

    if (app.layoutBuilder) {
      toState = 'editApp'
    } else {
      toState = app.type === 'embed' ? 'editForm' : 'editLegacy'
    }

    return {
      name: toState,
      params: {
        editAppId: app._id,
      },
    }
  })

  const appSettings = computed(() => {
    const { app } = context.props
    let toState

    if (app.layoutBuilder) {
      toState = 'appSettings'
    } else {
      toState = app.type === 'embed' ? 'formSettings' : 'legacySettings'
    }

    return {
      name: toState,
      params: {
        editAppId: app._id,
      },
    }
  })

  const withAccount = (app) => ({
    ...app,
    account: accountObj(),
  })

  const makePreviewUrl = (app) => {
    return previewLink(withAccount(app))
  }

  const installLink = (app) => {
    return makeInstallLink(withAccount(app))
  }

  const makePreviewImage = (app, thumb) => {
    return getPreviewImage(app, thumb)
  }

  const copyEmbedCode = async (app) => {
    await writeDataToClipboard(embedCode(withAccount(app)))
    ToastProgrammatic.open({
      message: 'Copied to clipboard.',
      type: 'success',
    })
  }

  const copyShortUrl = async (app) => {
    await writeDataToClipboard(app.micrositeShortUrl)
    ToastProgrammatic.open({
      message: 'Copied to clipboard.',
      type: 'success',
    })
  }

  return {
    fromNow,
    formatDate,
    demoClass,
    leadsBrandingPlural,
    leadsBrandingSingle,
    makePreviewUrl,
    installLink,
    copyEmbedCode,
    copyShortUrl,
    makePreviewImage,
    appLink,
    appSettings,
    withAccount,
  }
}
